export default __webpack_public_path__ + "static/media/MCO .785994e9.svg";